export const steppersUtils = (stepsArr: Array<string>) => {
  const steps = stepsArr;

  const getIndexByName = (name: string) => steps.indexOf(name);
  const getNextNameOfCurrentName = (currentName: string) =>
    steps[getIndexByName(currentName) + 1] || currentName;
  const getPrevNameOfCurrentName = (currentName: string) =>
    steps[getIndexByName(currentName) - 1] || currentName;

  return {
    getIndexByName,
    getPrevNameOfCurrentName,
    getNextNameOfCurrentName,
  };
};



// WEBPACK FOOTER //
// ./src/uikit/components/AppSteppers/utils.ts